import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

export function initSwipers() {
  document.querySelectorAll(".js-swiper").forEach((el) => {
    const options = JSON.parse(el.dataset.options || "{}");
    const slider = el.closest(".slider") ? el.closest(".slider") : el;

    const next = slider.querySelector(".swiper-button-next");
    const prev = slider.querySelector(".swiper-button-prev");
    const pagination = slider.querySelector(".swiper-pagination");

    // Breakpoints start
    const desktopSlides =
      options.slidesPerView === "auto"
        ? "auto"
        : Number(options.slidesPerView || 4);

    const defaultBreakpoints = (desktopSlides) => ({
      768: {
        slidesPerView: Math.max(2, desktopSlides - 1),
      },
      992: {
        slidesPerView: desktopSlides,
      },
    });

    const useBreakpoints = options.breakpoints !== false;

    let breakpoints;

    if (!useBreakpoints) {
      breakpoints = undefined;
    } else if (options.breakpoints) {
      breakpoints = Object.entries({
        ...defaultBreakpoints(desktopSlides),
        ...options.breakpoints,
      }).reduce((acc, [bp, config]) => {
        acc[bp] = {
          ...(defaultBreakpoints(desktopSlides)[bp] || {}),
          ...config,
        };
        return acc;
      }, {});
    } else {
      breakpoints = defaultBreakpoints(desktopSlides);
    }
    // Breakpoints end

    const swiper = new Swiper(el, {
      modules: [Navigation, Pagination, Autoplay],

      slidesPerView: useBreakpoints
        ? Math.max(1, desktopSlides - 2)
        : desktopSlides,
      spaceBetween: Number(options.spaceBetween || 0),
      loop: options.loop || false,
      speed: Number(options.speed || 500),
      watchOverflow: true,

      autoplay: options.autoplay
        ? {
            delay: Number(options.delay || 5000),
            disableOnInteraction: false,
          }
        : false,

      navigation:
        options.navigation && next && prev
          ? {
              nextEl: next,
              prevEl: prev,
            }
          : false,

      pagination:
        options.pagination && pagination
          ? {
              el: pagination,
              clickable: true,
            }
          : false,
      breakpoints,
      on: {
        init(swiper) {
          syncCatalogHeight(swiper);
        },

        resize(swiper) {
          syncCatalogHeight(swiper);
        },
      },
    });

    if (
      document.querySelector(".js-catalog-menu") &&
      el.classList.contains("section-carousel")
    ) {
      syncCatalogHeight(swiper);
    }
    function syncCatalogHeight(swiper) {
      const catalog = document.querySelector(".js-catalog-menu");

      if (!catalog || !swiper.el.closest(".with-catalog")) {
        return;
      }

      catalog.style.height = `${swiper.el.offsetHeight}px`;
    }
  });
}
